import { inject, Injectable } from '@angular/core';
import { ProductResource } from '@df/catalog/product/product.resource';
import { History } from '@df/session/api/history/history';
import { CustomerHistoryResolver } from '@df/session/customer/customer-history.resolver';

@Injectable({
    providedIn: 'root'
})
export class LocalCustomerHistoryResolver extends CustomerHistoryResolver {
    private productResource = inject(ProductResource);

    override async resolve(): Promise<History> {
        const history = await super.resolve();
        const productIds = history.orders.flatMap(order => order.items.map(item => item.data?.product_id));
        try {
            await this.productResource.loadAllIds(productIds, 2);
        } catch (error) {}

        return history;
    }
}
